/**
 * A one-line store whose only job is to let the "Show the tour again" button
 * (over in the About screen) ask the walkthrough overlay to replay, without the
 * two having to know about each other. The overlay watches the nonce; bumping it
 * re-runs the tour from the top. A counter rather than a boolean so a second tap
 * always fires, even if the last replay left nothing else changed.
 */
import { create } from 'zustand';

interface WalkthroughState {
  /** Bumped to ask the overlay to replay the tour. */
  replayNonce: number;
  requestReplay: () => void;
}

export const useWalkthroughStore = create<WalkthroughState>((set) => ({
  replayNonce: 0,
  requestReplay: () => set((s) => ({ replayNonce: s.replayNonce + 1 })),
}));
